import sessionOfferTypes from "astrid-firestore/src/constants/sessionOfferTypes";

export default function isAnyRecorderInTeamOrOpenPosition(session) {
	return [sessionOfferTypes.ANY_RECORDER_IN_TEAM, sessionOfferTypes.OPEN_POSITION_RECORDER].includes(
		session.recorder,
	);
}
